// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__tARem","modal":"Modal_modal__e7TUW","header":"Modal_header__2z1Dk","closeBtn":"Modal_closeBtn__Vz9h-","content":"Modal_content__RZl+c"};